module.exports = __webpack_public_path__ + "static/UAdeskSlide3-3c2f9dd4f81bef0c86deaed0fd253255.png";